// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* YourNest VC Landing Page Styles */

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #FAFAFA;
}

::-webkit-scrollbar-thumb {
  background: #C8473A;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #B74F40;
}

/* Selection color */
::selection {
  background: #C8473A;
  color: white;
}

/* Line clamp utilities */
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Animation utilities */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

/* Gradient text */
.text-gradient {
  background: linear-gradient(135deg, #C8473A 0%, #B74F40 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Button hover effects */
button, a {
  transition: all 0.3s ease;
}

/* Card hover effects */
.card-hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-4px);
}

/* Wrap text around images in prose content (blog, newsletters, news) */
.prose img[data-float="left"],
.prose-sm img[data-float="left"],
.prose-lg img[data-float="left"],
.prose img[align="left"],
.prose-sm img[align="left"],
.prose-lg img[align="left"],
.prose img[style*="float: left"],
.prose img[style*="float:left"],
.prose-sm img[style*="float: left"],
.prose-sm img[style*="float:left"],
.prose-lg img[style*="float: left"],
.prose-lg img[style*="float:left"] {
  float: left;
  margin: 0 1em 0.5em 0;
  max-width: 50%;
  height: auto;
}
.prose img[data-float="right"],
.prose-sm img[data-float="right"],
.prose-lg img[data-float="right"],
.prose img[align="right"],
.prose-sm img[align="right"],
.prose-lg img[align="right"],
.prose img[style*="float: right"],
.prose img[style*="float:right"],
.prose-sm img[style*="float: right"],
.prose-sm img[style*="float:right"],
.prose-lg img[style*="float: right"],
.prose-lg img[style*="float:right"] {
  float: right;
  margin: 0 0 0.5em 1em;
  max-width: 50%;
  height: auto;
}
.prose img[data-float="block"],
.prose img:not([data-float]):not([align]),
.prose-sm img[data-float="block"],
.prose-sm img:not([data-float]):not([align]),
.prose-lg img[data-float="block"],
.prose-lg img:not([data-float]):not([align]),
.prose img[align="middle"],
.prose img[align="center"],
.prose-sm img[align="middle"],
.prose-sm img[align="center"],
.prose-lg img[align="middle"],
.prose-lg img[align="center"] {
  float: none;
  display: block;
  max-width: 100%;
  height: auto;
}
/* Fallback: any img in newsletter/content prose that has inline float */
.prose img[style*="float"],
.prose-sm img[style*="float"],
.prose-lg img[style*="float"] {
  height: auto;
  max-width: 100%;
}
/* Clearfix after floated content in prose */
.prose::after,
.prose-sm::after,
.prose-lg::after {
  content: "";
  display: table;
  clear: both;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;;;;;;;;;;;;EAYE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;AACA;;;;;;;;;;;;EAYE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;AACA;;;;;;;;;;;;EAYE,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA,wEAAwE;AACxE;;;EAGE,YAAY;EACZ,eAAe;AACjB;AACA,4CAA4C;AAC5C;;;EAGE,WAAW;EACX,cAAc;EACd,WAAW;AACb","sourcesContent":["/* YourNest VC Landing Page Styles */\n\n/* Smooth scrolling */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #FAFAFA;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #C8473A;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #B74F40;\n}\n\n/* Selection color */\n::selection {\n  background: #C8473A;\n  color: white;\n}\n\n/* Line clamp utilities */\n.line-clamp-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Animation utilities */\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n/* Gradient text */\n.text-gradient {\n  background: linear-gradient(135deg, #C8473A 0%, #B74F40 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Button hover effects */\nbutton, a {\n  transition: all 0.3s ease;\n}\n\n/* Card hover effects */\n.card-hover {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card-hover:hover {\n  transform: translateY(-4px);\n}\n\n/* Wrap text around images in prose content (blog, newsletters, news) */\n.prose img[data-float=\"left\"],\n.prose-sm img[data-float=\"left\"],\n.prose-lg img[data-float=\"left\"],\n.prose img[align=\"left\"],\n.prose-sm img[align=\"left\"],\n.prose-lg img[align=\"left\"],\n.prose img[style*=\"float: left\"],\n.prose img[style*=\"float:left\"],\n.prose-sm img[style*=\"float: left\"],\n.prose-sm img[style*=\"float:left\"],\n.prose-lg img[style*=\"float: left\"],\n.prose-lg img[style*=\"float:left\"] {\n  float: left;\n  margin: 0 1em 0.5em 0;\n  max-width: 50%;\n  height: auto;\n}\n.prose img[data-float=\"right\"],\n.prose-sm img[data-float=\"right\"],\n.prose-lg img[data-float=\"right\"],\n.prose img[align=\"right\"],\n.prose-sm img[align=\"right\"],\n.prose-lg img[align=\"right\"],\n.prose img[style*=\"float: right\"],\n.prose img[style*=\"float:right\"],\n.prose-sm img[style*=\"float: right\"],\n.prose-sm img[style*=\"float:right\"],\n.prose-lg img[style*=\"float: right\"],\n.prose-lg img[style*=\"float:right\"] {\n  float: right;\n  margin: 0 0 0.5em 1em;\n  max-width: 50%;\n  height: auto;\n}\n.prose img[data-float=\"block\"],\n.prose img:not([data-float]):not([align]),\n.prose-sm img[data-float=\"block\"],\n.prose-sm img:not([data-float]):not([align]),\n.prose-lg img[data-float=\"block\"],\n.prose-lg img:not([data-float]):not([align]),\n.prose img[align=\"middle\"],\n.prose img[align=\"center\"],\n.prose-sm img[align=\"middle\"],\n.prose-sm img[align=\"center\"],\n.prose-lg img[align=\"middle\"],\n.prose-lg img[align=\"center\"] {\n  float: none;\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n/* Fallback: any img in newsletter/content prose that has inline float */\n.prose img[style*=\"float\"],\n.prose-sm img[style*=\"float\"],\n.prose-lg img[style*=\"float\"] {\n  height: auto;\n  max-width: 100%;\n}\n/* Clearfix after floated content in prose */\n.prose::after,\n.prose-sm::after,\n.prose-lg::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
